import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import DonatePage from "./pages/DonatePage";
import MadrassahPage from "./pages/MadrassahPage";
import YouthProgramPage from "./pages/YouthProgramPage";
import MembershipPage from "./pages/MembershipPage";
import EventsPage from "./pages/EventsPage";
import AdminPage from "./pages/AdminPage";
import { fetchSiteSettings } from "./services/api";

// Layout wrapper to conditionally show header/footer
const Layout = ({ children, shahadatMode, shahadatMessage }) => {
  const location = useLocation();
  const isAdminPage = location.pathname === '/admin';
  
  return (
    <>
      <ScrollToTop />
      {!isAdminPage && <Header shahadatMode={shahadatMode} shahadatMessage={shahadatMessage} />}
      <main>{children}</main>
      {!isAdminPage && <Footer />}
    </>
  );
};

function App() {
  const [shahadatMode, setShahadatMode] = useState(false);
  const [shahadatMessage, setShahadatMessage] = useState('');
  const [heroBanner, setHeroBanner] = useState('');

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const settings = await fetchSiteSettings();
        setShahadatMode(settings.shahadat_mode);
        setShahadatMessage(settings.shahadat_message || '');
        setHeroBanner(settings.hero_banner || '');
      } catch (e) { /* fallback: no mourning mode */ }
    };
    loadSettings();
  }, []);

  // Apply/remove shahadat class on body
  useEffect(() => {
    if (shahadatMode) {
      document.body.classList.add('shahadat-mode');
    } else {
      document.body.classList.remove('shahadat-mode');
    }
  }, [shahadatMode]);

  return (
    <div className="App">
      <BrowserRouter>
        <Layout shahadatMode={shahadatMode} shahadatMessage={shahadatMessage}>
          <Routes>
            <Route path="/" element={<HomePage shahadatMode={shahadatMode} shahadatMessage={shahadatMessage} heroBanner={heroBanner} />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/madrassah" element={<MadrassahPage />} />
            <Route path="/youth-program" element={<YouthProgramPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
